import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'

import style from './MyhouseRegisterLayout.module.scss'

import SkipNavigation from '@Components/atoms/SkipNavigation'
import { landAxios } from '@Root/utils/landAxios'
import useMyhouseRegister from '@Hooks/myhouse/useMyhouseRegister'
import MyhouseRegisterRestrictCountOverPopup from '@Components/atoms/MyhouseRegisterRestrictCountOverPopup'
import useUser from '@Hooks/user/useUser'
import MyhouseRegisterRestrictGroupIdPopup from '@Components/atoms/MyhouseRegisterRestrictGroupIdPopup'
import MyhouseRegisterRestrictSnsIdPopup from '@Components/atoms/MyhouseRegisterRestrictSnsIdPopup'
import MyhouseRegisterRestrictAgePopup from '@Components/atoms/MyhouseRegisterRestrictAgePopup'
import Confirm from '@Components/atoms/Confirm'
import ToastMessage from '@Components/atoms/ToastMessage'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import useModal from '@Hooks/myhouse/useModal'
import { handleNclick, handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

type Props = {
  children: React.ReactNode
}

const MyhouseRegisterLayout: React.FC<Props> = ({ children }: Props) => {
  const { myhouseNo } = useParams<{ myhouseNo: string }>()
  const { myhouseRegister } = useMyhouseRegister()
  const [showCountOverPopUp, setShowCountOverPopUp] = useState<boolean>(false)
  const { user } = useUser()
  const history = useHistory()
  const { open } = useModal()
  const isModify = Boolean(myhouseRegister.myHouseNo)

  useEffect(() => {
    if (!myhouseNo && !myhouseRegister.myHouseNo) {
      landAxios
        .get(`/myhouse/count/over`)
        .then((res) => {
          if (res.data) {
            open(MODAL_TYPE.MYHOUSE_LIMITED)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }, [])

  const handleCloseClick = (evt: React.SyntheticEvent) => {
    if (history.length > 1) {
      history.goBack()
      return
    }
    handleNclick(isModify ? NCLICK.MY_HOUSE.REGISTER_EDIT.CLOSE : NCLICK.MY_HOUSE.REGISTER.CLOSE, evt)

    if (document.referrer && !document.referrer.includes(`//nid.naver.com/`) && !document.referrer.includes('/myhouse')) {
      window.location.href = document.referrer
    } else {
      window.location.href = `${process.env.REACT_APP_LAND_WEB_URL}/myhouse`
    }
  }

  const handleRestrictPopupCloseClick = () => {
    if (window.location.pathname.includes('myasset')) {
      window.location.href = `${process.env.REACT_APP_NAVER_MYMONEY_URL}`
    } else {
      window.location.href = `${process.env.REACT_APP_SPACE_WEB_URL}`
    }
  }

  return (
    <div id="wrap" className={`${style['wrap']} ${style['wrap_myhouse']}`}>
      <SkipNavigation />
      {children}
      <Confirm />
      <ToastMessage />
      <MyhouseRegisterRestrictCountOverPopup
        showPopup={showCountOverPopUp}
        onButtonClick={(evt: React.SyntheticEvent) => {
          handleCloseClick(evt)
        }}
      />
      {(user.isGroupId && (
        <MyhouseRegisterRestrictGroupIdPopup userNickName={user.userNickName} onButtonClick={handleNclickMix(NCLICK.MY_HOUSE.RESTRICT.ID, handleRestrictPopupCloseClick)} />
      )) ||
        (user.isSnsId && (
          <MyhouseRegisterRestrictSnsIdPopup userNickName={user.userNickName} onButtonClick={handleNclickMix(NCLICK.MY_HOUSE.RESTRICT.ID, handleRestrictPopupCloseClick)} />
        )) ||
        (user.userOld < 14 && (
          <MyhouseRegisterRestrictAgePopup userNickName={user.userNickName} onButtonClick={handleNclickMix(NCLICK.MY_HOUSE.RESTRICT.AGE, handleRestrictPopupCloseClick)} />
        ))}
    </div>
  )
}

export default MyhouseRegisterLayout
